import firebase from 'firebase/app'
import 'firebase/auth'

const config = {
    apiKey: "AIzaSyDVWWAqqRAb6_ywxszrUh0KkTaZhigTJCY",
    authDomain: "routine-e5956.firebaseapp.com",
    databaseURL: "https://routine-e5956.firebaseio.com",
    projectId: "routine-e5956",
    storageBucket: "routine-e5956.appspot.com",
    messagingSenderId: "288500769045",
    appId: "1:288500769045:web:8534bf42466b3e60"
}

firebase.initializeApp(config)